<template>
<div>
    <section class="content">
      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Settlement Create</h3>
          
          <div class="box-tools pull-right">
            <a :href="`${this.$axios.defaults.baseURL}/sattlement/export/excel`" class="btn btn-box-tool">
              <i class="fa fa-file-excel-o"></i> Download Excel
            </a>
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
          </div>
        </div>
        <div class="box-body">
            
          <form role="form">
            <div class="row">
              <div class="col-md-3">
                <!-- text input -->

                <div class="form-group">
                  <label>Select Branch <span class="red">*</span></label>
                  <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getLoanMember"></v-select>
                    
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
              </div>
              <div class="col-md-3">
                <!-- text input -->

                <div class="form-group">
                  <label>Plan Type <span class="red">*</span></label>
                  <select
                    v-model="form.planType"
                    name="planType"
                    class="form-control"
                    @change="getLoanMember"
                    :class="{ 'is-invalid': form.errors.has('planType') }"
                  >
                    <option v-if="!form.planType" selected value="">
                      Select plan Type
                    </option>
                    <option value="individual">Individual</option>
                    <option value="group">Group</option>
                  </select>
                  <has-error :form="form" field="planType"></has-error>
                </div>
              </div>
              <div class="col-md-3" v-if="form.planType == 'group'">
                <!-- text input -->
                <div class="form-group" >
                  <label>Group </label>
                  
                  <v-select v-model="colC"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="getLoanMember">
                    
                  </v-select>
                  <has-error
                    :form="form"
                    field="collection_center_id"
                  ></has-error>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <!-- text input -->

                <div class="form-group bg-light">
                  <label>Select Member Id <span class="red">*</span></label>
                  <v-select v-model="mem"  name="member_id" label="name" :options="memberloanplans" placeholder="Select Member" v-on:input="getMemberLoanDetail">
                          
                  </v-select>
                  
                  <has-error
                    :form="form"
                    field="member_id"
                  ></has-error>
                  <has-error :form="form" field="member_id"></has-error>
                </div>
              </div>
              
            </div>
            <hr>
          </form>
              
          <form role="form" @submit.prevent="editMode ? updateLoanSettlement() : loanSettlement()">
            <div class="row">
              <div class="col-sm-3">
                <!-- text input -->

                <div class="form-group">
                  <label>Plan Name </label>
                  <input
                    type="text"
                    v-model="form.planName"
                    name="planName"
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('planName') }"
                    readonly
                  />
                  <has-error :form="form" field="planName"></has-error>
                </div>

                <div class="form-group">
                  <label>Total Installment Paid</label>
                  <input
                    type="text"
                    v-model="form.totalInstallmentPaid"
                    name="totalInstallmentPaid"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('totalInstallmentPaid'),
                    }"
                    readonly
                  />
                  <has-error
                    :form="form"
                    field="totalInstallmentPaid"
                  ></has-error>
                </div>

                <div class="form-group">
                  <label>Reason </label>
                  <select
                    v-model="form.reason"
                    name="reason"
                    required
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('reason') }"
                  >
                    <option value="PrePayment">PrePayment</option>
                    <option value="Death">Death (Account Closed)</option>
                    <option value="First-Payment-Default">X01 -> First Payment Default</option>
                    <option value="Death-Written-off">X02 -> Death (Written-off)</option>
                    <option value="Written-off">X02 -> Written-off</option>
                    <option value="Settled">X03 -> Settled</option>
                    <option value="Willful-Default-Status">X03 -> Willful Default Status</option>
                    <option value="Suilt-Field-Willful-Default-Status">X04 -> Suilt Field, Willful Default Status</option>
                    <option value="Untagged">X09 -> Untagged</option>
                    <option value="Not-Applicable">X10 -> Not Applicable</option>
                  </select>
                  <has-error :form="form" field="reason"></has-error>
                </div>

                <div class="form-group">
                  <label>Loan Pre Closing Charge Type </label>
                  <select
                    v-model="form.loanPreClosingChargeType"
                    name="loanPreClosingChargeType"
                    required
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('loanPreClosingChargeType') }"
                    readonly
                  >
                    <option value="percent">Percent</option>
                    <!-- <option value="fixed">Fixed</option> -->
                  </select>
                  <has-error :form="form" field="loanPreClosingChargeType"></has-error>
                </div>

                <div class="form-group" v-if="form.loanPreClosingCharge > 0">
                  <label>Total Amount Due With Pre Loan Closing Charge </label>
                  <input
                    type="text"
                    v-model="form.totalAmtDueWithPreClosingCharge"
                    name="totalAmtDueWithPreClosingCharge"
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('totalAmtDueWithPreClosingCharge') }"
                    readonly
                  />
                  <has-error :form="form" field="totalAmtDueWithPreClosingCharge"></has-error>
                </div>

                <div class="form-group">
                  <button
                    v-if="mem"
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    CREATE SETTLEMENT
                  </button>
                  <button v-if="mem" v-show="editMode" type="submit" class="btn btn-primary">
                     UPDATE SETTLEMENT
                  </button>
                </div>
              </div>
              <div class="col-sm-3">
                <!-- text input -->

                <div class="form-group">
                  <label>Total Amount </label>
                  <input
                    type="text"
                    v-model="form.planAmount"
                    name="planAmount"
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('planAmount') }"
                    readonly
                  />
                  <has-error :form="form" field="planAmount"></has-error>
                </div>

                <div class="form-group">
                  <label>Total Amount Paid</label>
                  <input
                    type="text"
                    v-model="form.totalAmountPaid"
                    name="totalAmountPaid"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('totalAmountPaid'),
                    }"
                    readonly
                  />
                  <has-error
                    :form="form"
                    field="totalAmountPaid"
                  ></has-error>
                </div>

                <div class="form-group">
                  <label>Total Amount Due Without Interest</label>
                  <input
                    type="text"
                    v-model="form.totalAmountDueWithoutInterest"
                    name="totalAmountDueWithoutInterest"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has(
                        'totalAmountDueWithoutInterest'
                      ),
                    }"
                    readonly
                  />
                  <has-error
                    :form="form"
                    field="totalAmountDueWithoutInterest"
                  ></has-error>
                </div>
                <div class="form-group">
                  <label>Total Current Due Amount</label>
                  <input
                    type="text"
                    v-model="form.amt"
                    name="amt"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has(
                        'amt'
                      ),
                    }"
                    readonly
                  />
                  <has-error
                    :form="form"
                    field="amt"
                  ></has-error>
                </div>
                <div class="form-group">
                  <button
                    v-if="mem"
                    type="button"
                    @click="newModal"
                    class="btn btn-success"
                  >
                    COLLECT CURRENT DUE
                  </button>
                </div>
              </div>
              <div class="col-sm-3">
                <!-- text input -->

                <div class="form-group">
                  <label>Application Number </label>
                  <input
                    type="text"
                    v-model="form.applicationNumber"
                    name="applicationNumber"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('applicationNumber'),
                    }"
                    readonly
                  />
                  <has-error
                    :form="form"
                    field="applicationNumber"
                  ></has-error>
                </div>

                <div class="form-group">
                  <label>Total Installment Due</label>
                  <input
                    type="text"
                    v-model="form.totalInstallmentDue"
                    name="totalInstallmentDue"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('totalInstallmentDue'),
                    }"
                    readonly
                  />
                  <has-error
                    :form="form"
                    field="totalInstallmentDue"
                  ></has-error>
                </div>

                <div class="form-group">
                  <label>Payment Date</label>
                  <input
                    type="date"
                    v-model="form.sattlementDate"
                    name="sattlementDate"
                    @change="settmentDateWise"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('sattlementDate'),
                    }"
                  />
                  <has-error :form="form" field="sattlementDate"></has-error>
                </div>
                <div class="form-group">
                  <label>Select Ledger Account </label>
                  <select
                    v-model="form.branch_ledger_id"
                    name="branch_ledger_id"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('branch_ledger_id'),
                    }"
                  >
                    <option v-if="!form.branch_ledger_id" selected value="">
                      Select Ledger Account
                    </option>
                    <option
                      :value="brLedger.id"
                      v-for="brLedger in payment_ledgers"
                      :key="brLedger.id"
                    >
                      {{brLedger.name}} {{brLedger.remark}}
                    </option>
                  </select>
                  <has-error :form="form" field="branch_ledger_id"></has-error>
                </div>
                <div class="form-group">
                  <label>Remark</label>
                  <input
                    type="text"
                    v-model="form.remark"
                    name="remark"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has(
                        'remark'
                      ),
                    }"
                  />
                  <has-error
                    :form="form"
                    field="remark"
                  ></has-error>
                </div>
              </div>

              <div class="col-sm-3">
                <div class="form-group">
                  <label>Member Name </label>
                  <input
                    type="text"
                    v-model="form.memberName"
                    name="memberName"
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('memberName') }"
                    readonly
                  />
                  <has-error :form="form" field="memberName"></has-error>
                </div>

                <div class="form-group">
                  <label>Total Amount Due</label>
                  <input
                    type="text"
                    v-model="form.totalAmountDue"
                    name="totalAmountDue"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('totalAmountDue'),
                    }"
                    readonly
                  />
                  <has-error
                    :form="form"
                    field="totalAmountDue"
                  ></has-error>
                </div>

                <div class="form-group">
                  <label>Loan Pre Closing Charge (%)</label>
                  <input
                    type="number"
                    step=".01"
                    v-model="form.loanPreClosingCharge"
                    @change="afterAmtLoanPreClosingCharge"
                    name="loanPreClosingCharge"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has(
                        'loanPreClosingCharge'
                      ),
                    }"
                  />
                  <has-error
                    :form="form"
                    field="loanPreClosingCharge"
                  ></has-error>
                </div>

                <div class="form-group">
                  <label>Total Amount Paid Settlement</label>
                  <input
                    type="number"
                    required
                    v-model="form.totalAmountPaidWithSettlement"
                    name="totalAmountPaidWithSettlement"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has(
                        'totalAmountPaidWithSettlement'
                      ),
                    }"
                  />
                  <has-error
                    :form="form"
                    field="totalAmountPaidWithSettlement"
                  ></has-error>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all Settlement
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->
      <div class="box info-box">
        <div class="box-header with-border">
          Search By
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3" v-if="canAccess('branch-create')">
              <label for="Branch">Branch</label>
              <v-select v-model="branchFilter" name="branch_id" label="name" :options="branches" v-on:input="branchRecordWithLoadSettlementData" placeholder="Select Branch"></v-select>
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            <div class="col-md-3" v-if="form.planType == 'group'"> 
              <label>Collection Center </label>
              <v-select v-model="colC"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="loadSettlementData" required> 
              </v-select>
            </div>
            <div class="col-md-3"> 
              <label>Customer</label>
              <v-select v-model="member"  name="collection_center_id" label="name" :options="members" placeholder="Select Group" v-on:input="loadSettlementDataWithCustomer" required> 
              </v-select>
            </div>
            <div class="col-md-3">
              <label for="date">Date</label>
              <input type="date" v-model="form.paymentDate" name="paymentDate" @change="loadSettlementData(1)" class="form-control" placeholder="EMI Date">
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label
                  >Select Status <span class="red">*</span></label
                >
                <select
                  v-model="form.status"
                  name="status"
                  class="form-control"
                  @change="loadSettlementData"
                  :class="{
                    'is-invalid': form.errors.has('status'),
                  }"
                >
                  <option v-if="!form.status" selected value="">
                    Select Status
                  </option>
                  <option value="pending">Pending</option>
                  <option value="processing">Processing</option>
                  <option value="sattlement">Settlement</option>
                  <option value="complete">Complete</option>
                </select>
                <has-error :form="form" field="status"></has-error>
              </div>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('bank-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Settlement List</h3>
          
          <div class="box-tools">
            <!-- <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('bank-create')">
              <i class="fa fa-plus"></i> Add New
            </button> -->
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="loadSettlementData()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="loadSettlementData()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="loadSettlementData()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Loan Id</th>
                <th class="hidden-xs">Mem Name</th>
                <th class="hidden-xs">(C/O) Alias</th>
                <th class="hidden-xs">Mem Mob</th>
                <th class="hidden-xs">Plan Amt</th>
                <th class="hidden-xs">Paid Amt</th>
                <th class="hidden-xs">Due Amt</th>
                <th class="hidden-xs">Settle Amt</th>
                <th class="hidden-xs">Settle Date</th>
                <th class="hidden-xs">Created By</th>
                <th class="hidden-xs">Pay Mode</th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td>{{ row.member_loan_plan.applicationNo }}</td>
                <td class="hidden-xs">{{ row.member.name }} - {{ row.member.code }}</td>
                <td class="hidden-xs">{{ row.member.alias }}</td>
                <td class="hidden-xs">{{ row.member.mobile }}</td>
                <td class="hidden-xs">{{ row.planAmount }}</td>
                <td class="hidden-xs">{{ row.totalAmountPaid }}</td>
                <td class="hidden-xs">{{ row.totalAmountDue }}</td>
                <td class="hidden-xs">{{ row.totalAmountPaidWithSettlement }}</td>
                <td class="hidden-xs">{{ row.sattlementDate | myDate }}</td>
                <td class="hidden-xs">{{ row.created_by.name }}</td>
                <td class="hidden-xs">{{ row.branch_ledger.ledger.name }}</td>
                <td class="hidden-xs">{{ row.status }}</td>
                <td>
                  <div class="btn-group">
                    <button v-if="row.status !== 'approved'"
                      @click="editModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      @click="viewModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <button
                      @click="viewPrintModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-print"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-delete')"
                      @click="deleteModal(row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="loadSettlementData(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="loadSettlementData(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="loadSettlementData( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="loadSettlementData( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="loadSettlementData( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="loadSettlementData( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="loadSettlementData( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="loadSettlementData( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="loadSettlementData( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="loadSettlementData( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="loadSettlementData( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="loadSettlementData( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="loadSettlementData( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="loadSettlementData( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="loadSettlementData( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="loadSettlementData( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="loadSettlementData(null, 'next')"><a href="#">Next</a></li>
                <li @click="loadSettlementData(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title">Settlement Details</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="card">
              
                    <!-- /.card-header -->
                    <div class="card-body" v-if="settlementDetails">
                      <ul class="todo-list ui-sortable" data-widget="todo-list">
                        <li v-if="settlementDetails.branch">
                          <span class="text">Branch Name : </span> {{settlementDetails.branch.name}}
                        </li>
                        <li v-if="settlementDetails.branch_ledger">
                          <span class="text">Payment Mode : </span> {{settlementDetails.branch_ledger.ledger.name}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member Name : </span> {{settlementDetails.member.name}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member code : </span> {{settlementDetails.member.code}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member Alias : </span> {{settlementDetails.member.alias}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member Contact Number : </span> {{settlementDetails.member.mobile}}
                        </li>
                        <li v-if="settlementDetails.member">
                          <span class="text">Member Email : </span> {{settlementDetails.member.email}}
                        </li>
                        <li v-if="settlementDetails.member_loan_plan">
                          <span class="text">Loan Application Number : </span> {{settlementDetails.member_loan_plan.applicationNo}}
                        </li>
                        <li v-if="settlementDetails.member_loan_plan">
                          <span class="text">Loan EMI Start Date : </span> {{settlementDetails.member_loan_plan.emiStartDate}}
                        </li>
                        <li v-if="settlementDetails.member_loan_plan">
                          <span class="text">Loan EMI End Date : </span> {{settlementDetails.member_loan_plan.emiEndDate}}
                        </li>
                        <li v-if="settlementDetails.member_loan_plan">
                          <span class="text">Loan Type : </span> {{settlementDetails.member_loan_plan.type}}
                        </li>
                        <li v-if="settlementDetails.collection_center">
                          <span class="text">Collection Center : </span> {{settlementDetails.collection_center.name}}
                        </li>
                        <li>
                          <span class="text">Total Plan amount : </span> {{settlementDetails.planAmount}}
                        </li>
                        <li>
                          <span class="text">Total Amount Paid : </span> {{settlementDetails.totalAmountPaid}}
                        </li>
                        
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card">
                    <ul class="todo-list ui-sortable" data-widget="todo-list">
                      <li>
                        <span class="text">Total Amount Due Without Interest : </span> {{settlementDetails.totalAmountDueWithoutInterest}}
                      </li>
                      <li>
                        <span class="text">Total Amount Due : </span> {{settlementDetails.totalAmountDue}}
                      </li>
                      <li>
                        <span class="text">Total Installment Paid : </span> {{settlementDetails.totalInstallmentPaid}}
                      </li>
                      <li>
                        <span class="text">Total Installment Due : </span> {{settlementDetails.totalInstallmentDue}}
                      </li>
                      <li>
                        <span class="text">Loan Pre Closing Charge Type : </span> {{settlementDetails.loanPreClosingChargeType}}
                      </li>
                      <li>
                        <span class="text">loanPreClosingCharge (%) : </span> {{settlementDetails.loanPreClosingCharge}}
                      </li>
                      <li>
                        <span class="text">Reason : </span> {{settlementDetails.reason}}
                      </li>
                      <li>
                        <span class="text">Settlement Date : </span> {{settlementDetails.sattlementDate}}
                      </li>
                      <li>
                        <span class="text">Remark : </span> {{settlementDetails.remark}}
                      </li>
                      <li v-if="settlementDetails.created_by">
                        <span class="text">Loan Settled By : </span> {{settlementDetails.created_by.name}}
                      </li>
                      <li>
                        <span class="text">Total Amount Paid With Settlement : </span> {{settlementDetails.totalAmountPaidWithSettlement}}
                      </li>
                      <li>
                        <span class="text">Settlement Status : </span> {{settlementDetails.status}}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.row -->
      <VIEWPRINTSETTLEMENT :seeRecordSettlement="seeRecordSettlement"></VIEWPRINTSETTLEMENT>

      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Payment Collection</h4>
            </div>
            <form @submit.prevent="collectPayment()">
              <div class="modal-body">
                <!-- right column -->
                
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Amount <span class="red">*</span></label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('amt') }"
                              required
                            />
                            <has-error :form="form" field="amt"></has-error>
                          </div>

                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="brLedger.id"
                                v-for="brLedger in brLedgers"
                                :key="brLedger.id"
                              >
                                {{brLedger.name}} {{brLedger.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Payment Date <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('paymentDate'),
                              }"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Attendance <span class="red">*</span></label
                            >
                            <select
                              v-model="form.attendance"
                              name="attendance"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('attendance'),
                              }"
                            >
                              <option selected value="present">Present</option>
                              <option value="absent">Absent</option>
                            </select>
                            <has-error :form="form" field="attendance"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Remark </label>
                            <input
                              v-model="form.remark"
                              type="text"
                              name="remark"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('remark') }"
                            />
                            <has-error :form="form" field="remark"></has-error>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="box box-default" v-if="mem">
                            <div class="box-header with-border">
                              <i class="fa fa-bullhorn"></i> 
                              <h3 class="box-title">Customer Details</h3>
                            </div> 
                            <div class="box-body">
                              
                              <!-- <div class="text-center">
                                <img
                                  class="profile-user-img img-fluid img-circle"
                                  :src= this.photo
                                  alt="User profile picture"
                                />
                              </div> -->
                              <div class="callout callout-info">
                                <h4>Member</h4>
                                <p>{{mem.name}}</p>
                                <h4>Mobile No</h4>
                                <p>{{mem.mobile}}</p>
                                <!-- <h4>Address</h4>
                                <p v-if="memberRecord">{{memberRecord.address}}</p> -->
                              </div> 
                              <!-- <div class="callout callout-danger" v-if="memberloanplan.collection_center">
                                <h4>Group</h4>
                                <p>{{memberloanplan.collection_center.name}}</p>
                              </div> -->
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
               
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                >
                  CREATE
                </button>
                
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    </section>
         

</div>
</template>

<script>
import GetBranch from '../../mixins/BranchRecords'
import LoadSettlementData from '../../mixins/SettlementRecords'
import GetPaymentBranchLedgers from '../../mixins/PaymentBranchLedgers'
import VIEWPRINTSETTLEMENT from '../components/SettlementPrintView.vue'
export default {
  name: 'Sattlement',
  mixins: [GetBranch, LoadSettlementData, GetPaymentBranchLedgers],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      branches: [],
      dDtls: {},
      collectionCenters: [],
      branch: {},
      seeRecordSettlement: {},
      branchFilter: {},
      brLedgers: [],
      brLedger: {},
      members: [],
      payment_ledgers: [],
      colC: {},
      memberloanplans: [],
      emiRecords: [],
      emitotal: 0,
      mem: {},
      member: {},
      user_id: '',
      partialEMIRemainder: 0,
      userPlan: {},
      settlementDetails: {},
      form: new Form({
        id: '',
        branch_id: '',
        collection_center_id: '',
        member_id: '',
        member_loan_plan_id: '',
        amt: 0,
        totalInstallmentPaid: 0,
        planAmount: 0,
        totalAmountPaid: 0,
        totalAmountDueWithoutInterest: 0,
        branch_ledger_id: '',
        remark: '',
        reason: '',
        totalInstallmentDue: 0,
        sattlementDate: '',
        totalAmountDue: 0,
        totalAmountPaidWithSettlement: 0,
        status: '',
        loanPreClosingCharge: 0,
        loanPreClosingChargeType: 'percent',
        applicationNumber: '',
        planName: '',
        date: '',
        amount: 0,
        planType: '',
        numberOfEMI: 0,
        totalAmtDueWithPreClosingCharge: 0,
        memberName: ''
      }),
      columns: [
        {
          label: 'Loan Id',
          field: 'member_loan_plan.applicationNo'
        },
        {
          label: 'Mem Code',
          field: 'member.code'
        },
        {
          label: 'Mem Name',
          field: 'member.name'
        },
        {
          label: '(C/O) Alias',
          field: 'member.alias'
        },
        {
          label: 'Mem Mob',
          field: 'member.mobile'
        },
        {
          label: 'Plan Amt',
          field: 'planAmount'
        },
        {
          label: 'Paid Amt',
          field: 'totalAmountPaid'
        },
        {
          label: 'Due Amt',
          field: 'totalAmountDue'
        },
        {
          label: 'Settlement Amt',
          field: 'totalAmountPaidWithSettlement'
        },
        {
          label: 'Settlement Date',
          field: 'sattlementDate'
        },
        {
          label: 'Created By',
          field: 'created_by.name'
        },
        {
          label: 'Pay Mode',
          field: 'branch_ledger.ledger.name'
        },
        {
          label: 'Status',
          field: 'status'
        },
        {
          label: 'Actions',
          field: 'id',
          type: 'number'
        }
      ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    viewModal (row) {
      this.settlementDetails = row
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
    },
    viewPrintModal (row) {
      this.seeRecordSettlement = {}
      this.seeRecordSettlement = row
      $('#settlementReceiptView').modal({backdrop: 'static', keyboard: false})
    },
    getBranch () {
      this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getMembers () {
      var c = JSON.parse(localStorage.user)
      this.userStatus = ''
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          this.branch_record = `branch_id=${c.agent_profile.branch_id}`
        } else {
          this.branch_record = `&agent_id=${c.id}`
        }
      } else {
        this.branch_record = `branch_id=${this.form.branch_id}`
      }
      if (this.getSettingRecord === 'true') {
        this.userStatus = 'status=verified'
      }
      this.$axios
        .get('member?all=all&' + this.userStatus + '&' + this.branch_record, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.member_id === item.user.id) {
              this.mem = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    branchRecordWithLoadSettlementData () {
      this.form.branch_id = ''
      if (this.branchFilter) {
        this.form.branch_id = this.branchFilter.id
      }
      this.loadSettlementData()
    },
    loadSettlementDataWithCustomer () {
      if (this.member) {
        this.user_id = this.member.user_id
      }
      this.loadSettlementData()
    },
    newModal () {
      $('#newModal').modal({backdrop: 'static', keyboard: false})
     // this.loadDisbursement()
    },
    getCollectionCenter () {
      this.$axios
        .get('collectioncenter?all=all&branch_id=' + this.branch.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.collectionCenters = data.data
          _.forEach(this.collectionCenters, function (item, key) {
            this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    settmentDateWise () {
      $.each(this.emiRecords, function (key, value) {
        // alert(new Date(value.emiDate).toISOString().slice(0, 10))
        if (new Date(value.emiDate).toISOString().slice(0, 10) === this.form.sattlementDate) {
          alert('hello')
        }
      })
    },
    getLoanMember () {
      // var multiplestatus = ['pending', 'processing']
      // this.colC.id = ''
      if (this.form.planType === 'group') {
        this.getCollectionCenter()
        // alert(this.colC.id)
        this.form.collection_center_id = this.colC.id
      }
      if (this.form.planType === 'individual') {
        this.collectionCenters = []
        this.colC = {}
        this.colC.id = ''
      }
      this.editMode = false
      this.memberloanplans = []
      this.mem = {}
      this.form.planName = ''
      this.form.memberName = ''
      this.form.applicationNumber = ''
      this.form.totalAmountPaidWithSettlement = 0
      this.form.planAmount = 0
      this.form.numberOfEMI = 0
      this.form.totalInstallmentPaid = 0
      this.form.totalAmountPaid = 0
      this.form.totalAmountDue = 0
      this.form.totalInstallmentDue = 0
      this.form.totalAmountDueWithoutInterest = 0
      this.form.loanPreClosingCharge = 0
      this.form.totalAmtDueWithPreClosingCharge = 0
      this.form.branch_id = this.branch.id
      this.getPaymentBranchLedgers()
      this.$axios
        .get('memberloanplan?all=all&branch_id=' + this.branch.id + '&collection_center_id=' + this.colC.id + '&searchTerm=' + this.form.planType + '&multiplestatus[]=processing&multiplestatus[]=pending', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.memberloanplans = data.data
          _.forEach(this.memberloanplans, function (item, key) {
            if (item.status === 'pending' || item.status === 'processing') {
              this.memberloanplans[key].name = item.member.name + ' (' + item.member.code + ')' + '( Application Number - ' + item.applicationNo + ')'
              if (this.form.member_id === item.member.id) {
                this.mem = item
              }
            }
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('sattlement/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    getMemberLoanDetail () {
      let settleLoan = []
      let sls = ''
      settleLoan = this.rows
      for (let ro = 0; ro < settleLoan.length; ro++) {
        if (settleLoan[ro].member_loan_plan_id === this.mem.id && settleLoan[ro].status === 'approved') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'This Loan is already Settled!'
          })
          sls = 'approved'
        }
      }
      var i = 0
      var emiInterest = 0
      this.partialEMIRemainder = 0
      this.form.totalAmountDueWithoutInterest = 0
      this.form.totalInstallmentPaid = 0
      this.form.totalInstallmentDue = 0
      this.form.totalAmountPaidWithSettlement = 0
      this.form.numberOfEMI = 0
      this.emitotal = 0
      this.emiRecords = []
      this.userPlan = {}
      if (sls !== 'approved') {
        this.userPlan = JSON.parse(this.mem.disbursement.plan)
        this.form.branch_id = this.mem.branch_id
        this.form.member_id = this.mem.member_id
        this.form.member_loan_plan_id = this.mem.id
        this.form.planType = this.mem.type
        this.form.planName = this.userPlan.name
        this.form.planAmount = this.mem.totalAmt
        this.form.applicationNumber = this.mem.applicationNo
        this.form.memberName = this.mem.member.name
        this.form.totalAmountPaid = this.mem.receivedAmt
        this.form.totalAmountDue = this.form.planAmount - this.form.totalAmountPaid
        this.form.sattlementDate = new Date().toISOString().slice(0, 10)
        this.$axios
          .get('memberemi?all=all&member_loan_plan_id=' + this.mem.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            // console.log('record without date')
            this.emiRecords = data.data
            this.partialEMIRemainder = this.form.totalAmountPaid
            $.each(this.emiRecords, function (key, value) {
              this.emitotal += value.total
              this.form.numberOfEMI = this.form.numberOfEMI + 1
              // alert('emi total = ' + this.emitotal + ' and ' + this.form.totalAmountPaid)
              if (this.emitotal <= this.form.totalAmountPaid) {
                this.partialEMIRemainder = this.partialEMIRemainder - value.total
                this.form.totalInstallmentPaid = this.form.totalInstallmentPaid + 1
                // alert('hiiiiiiii')
              } else {
                if (i < 1) {
                  emiInterest = value.interest
                  i = i + 1
                  this.form.totalAmountDueWithoutInterest = this.form.totalAmountDueWithoutInterest - this.partialEMIRemainder
                }
                if (this.form.sattlementDate >= value.emiDate) {
                  this.form.amt = value.arrear
                }
                this.form.totalAmountDueWithoutInterest += value.principal
              }
            }.bind(this))
            this.form.totalInstallmentDue = this.form.numberOfEMI - this.form.totalInstallmentPaid
            if (emiInterest < this.partialEMIRemainder) {
              this.form.totalAmountDueWithoutInterest = this.form.totalAmountDueWithoutInterest + emiInterest
              this.form.totalAmountDueWithoutInterest = this.form.totalAmountDueWithoutInterest - this.partialEMIRemainder
            }
            if (this.form.totalAmountPaidWithSettlement < 1) {
              this.form.totalAmountPaidWithSettlement = this.form.totalAmountDueWithoutInterest
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    afterAmtLoanPreClosingCharge () {
      this.form.totalAmtDueWithPreClosingCharge = parseFloat(this.form.totalAmountDueWithoutInterest) + parseFloat(this.form.loanPreClosingCharge * this.form.totalAmountDueWithoutInterest / 100)
    },
    editModal (row) {
      this.editMode = true
      this.form.fill(row)
      this.form.applicationNumber = row.member_loan_plan.applicationNo
      this.form.memberName = row.member.name
      this.afterAmtLoanPreClosingCharge()
      this.getPaymentBranchLedgers()
      // row.branch_ledger.name = row.branch_ledger.ledger.name
      // this.brLedgers.push(row.branch_ledger)

      // this.form.branch_ledger_id = row.branch_ledger.id
      // this.brLedger[key].name = row.branch_ledger.ledger.name
      this.$axios
        .get('disbursement/' + row.member_loan_plan.disbursement_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.dDtls = data.data.plan
          // this.dDtls = JSON.parse(data.data.plan)
          this.form.planName = JSON.parse(this.dDtls).name
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    updateLoanSettlement () {
      // console.log('update data')
      if (this.form.planType === 'group') {
        this.$delete(this.form, 'member_id')
      }
      if (this.form.planType === 'individual') {
        // alert('hello')
        this.$delete(this.form, 'center_leader_id')
        this.$delete(this.form, 'collection_center_id')
      }
      this.$axios
        .put('sattlement/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          Toast.fire({
            icon: 'success',
            title: 'Loan Settlement Updated Successfully'
          })
          // this.editMode = false
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loanSettlement () {
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
      }
      this.$axios
        .post('sattlement', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          Toast.fire({
            icon: 'success',
            title: 'Dear User, Your Loan Settlemnt has been processed Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    }
  },
  components: {
    VIEWPRINTSETTLEMENT
  },
  created () {
    this.loadSettlementData()
    this.getMembers()
    this.getBranch()
    Fire.$on('AfterCreate', () => {
      this.loadSettlementData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// Settlement.vue?51ab4d4e